<template>
  <div class="content">
    <div class="inner_content">
      <div class="header">
        转出会员
      </div>
      <div class="box">
        <div class="flex">
          <div class="title">
            请输入卡号：
          </div>
          <div class="fixedWidth">
            <el-input size="small"></el-input>
          </div>
          <el-button type="primary" size="small">搜索</el-button>
        </div>
        <div class="flex">
          <div class="title"></div>
          <div class="name">姓名：<span class="color-red">张小小</span></div>
          <div class="name">会员等级：<span class="color-red">贵宾卡（1）</span></div>
          <div class="name">余额：<span class="color-red">780</span></div>
          <div class="name">积分数量：<span class="color-red">366</span></div>
          <div class="name">过期时间：<span class="color-red">无期限</span></div>
          <div class="name color-blue">会员信息</div>
        </div>
      </div>
      <div class="header">
        转入会员
      </div>
      <div class="box">
        <div class="flex">
          <div class="title">
            转入卡号：
          </div>
          <div class="fixedWidth">
            <el-input size="small"></el-input>
          </div>
          <el-button type="primary" size="small">快捷搜索</el-button>
        </div>
        <div class="flex">
          <div class="title"></div>
          <div class="name">姓名：<span class="color-red">张小小</span></div>
          <div class="name">会员等级：<span class="color-red">贵宾卡（1）</span></div>
          <div class="name">余额：<span class="color-red">780</span></div>
          <div class="name">积分数量：<span class="color-red">366</span></div>
          <div class="name">过期时间：<span class="color-red">无期限</span></div>
          <div class="name color-blue">会员信息</div>
        </div>
        <div class="flex">
          <div class="title">
            转入金额：
          </div>
          <div class="fixedWidth">
            <el-input size="small"></el-input>
          </div>
        </div>
        <div class="flex">
          <div class="title">
            会员密码：
          </div>
          <div class="fixedWidth">
            <el-input size="small"></el-input>
          </div>
        </div>
        <div class="flex">
          <div class="title">
          </div>
          <div class="fixedWidth">
            <el-button type="primary" size="small">转出</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      
    };
  },
  mounted() {
  },
  
};
</script>
<style lang="scss" scoped>
.content {
  padding: 0 26px 11px 20px;
  height: calc(100vh - 102px);
  border: 1px solid #f1f1f1;
  overflow: auto;
  min-width: 900px;
  background:rgba(240,242,245,1);
  .inner_content{
    background: #fff;
    padding: 0 24px;
    height: 100%;
    .header{
      height: 50px;
      line-height: 50px;
      font-size: 16px;
      border-bottom: 1px solid #f1f1f1;
    }
    
  }
}
// 通用样式
.flex{
  display: flex;
  align-items: center;
  padding: 10px 0px;
  .title{
    width: 100px;
    text-align: right;
  }
}
.color-red{
  color: red;
  padding-right: 10px;
}
.color-blue{
  color: #409eff;
}

</style>
